// Display identity for household members. Emails are the canonical
// identity everywhere (roster, splits, balances); these helpers only
// affect RENDERING. Names come from the Worker's people table (plan D19
// P6) with /api/me (`people`), so the balance card reads "Liz owes you";
// an email not in it falls back to a capitalized local part.

let names: Record<string, string> = {};

/** From /api/me's `people` (api.ts getMe and its warm-start cache). */
export function setPeople(people: Array<{ email: string; name: string }> | undefined): void {
  const next: Record<string, string> = {};
  for (const p of people ?? []) if (p?.email && p?.name) next[p.email.toLowerCase()] = p.name;
  names = next;
}

export function displayName(email: string): string {
  const key = email.toLowerCase();
  if (names[key]) return names[key];
  const at = key.indexOf('@');
  const local = at > 0 ? key.slice(0, at) : key;
  return local.charAt(0).toUpperCase() + local.slice(1);
}

// Letter-avatar tint index (0–7) for a merchant or person, by a hash of
// the lowercased name — the same hash as mobile's tintFor, so a vendor
// gets the same color on both clients. The colors themselves are the
// --tint-N tokens in globals.css (DS.avatarTints, plus dark variants).
const TINT_COUNT = 8;

export function tintIndex(name: string): number {
  const key = name.toLowerCase();
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return h % TINT_COUNT;
}
